import React, { useCallback, useMemo, useState } from 'react';
import { Tabs } from 'antd';
import styles from '../../s.module.less';
import { IClosedFunnelDetail } from 'types/operation';
import dayjs from 'dayjs';
import InfoCard from './InfoCard';
import BlocksTab from './BlocksTab';
import InfoModal from './InfoModal';

interface LeftPanelProps {
    info?: IClosedFunnelDetail;
    conditionOptions?: { label: string; value: string }[];
    statesOptions?: { label: string; value: string }[];
    typeOptions?: { label: string; value: string }[];
    currentTab: string;
    secondTab: string;
    setSecondTab: (key: string) => void;
    setCurrentTab: (key: string) => void;
    onSuccess?: () => void;
}

const LeftPanel: React.FC<LeftPanelProps> = ({ info, conditionOptions, statesOptions, typeOptions, currentTab, setCurrentTab, onSuccess, secondTab, setSecondTab }) => {
    const name = info?.basicInfo?.name;
    const lastModified = info?.basicInfo?.updatedAt;
    const [open, setOpen] = useState(false);
    const handleEdit = useCallback(() => {
        setOpen(true);
    }, []);

    const handleSuccess = useCallback(() => {
        setOpen(false);
        onSuccess?.();
    }, [onSuccess]);

    const handleCancel = useCallback(() => {
        setOpen(false);
    }, []);

    const tabItems = useMemo(() => [
        {
            key: 'info',
            label: 'Info',
            children: (
                <InfoCard
                    info={info}
                    onEdit={handleEdit}
                />
            ),
        },
        {
            key: 'blocks',
            label: 'Blocks',
            children: (
                <BlocksTab
                    secondTab={secondTab}
                    setSecondTab={setSecondTab}
                    questions={info?.questions}
                    filters={info?.filters}
                    onSuccess={handleSuccess}
                />
            ),
        },
    ], [handleEdit, handleSuccess, info, secondTab, setSecondTab]);

    return (
        <div className={styles.leftPanel}>
            <InfoModal
                info={info}
                conditionOptions={conditionOptions}
                statesOptions={statesOptions}
                typeOptions={typeOptions}
                open={open}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
            />
            <div className={styles.funnelTitle}>{name}</div>
            {
                lastModified && (
                    <div className={styles.lastModified}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10 6.66667V10L12.5 12.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85787 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85787 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Date last modified: {dayjs(lastModified).format('MMM D, YYYY at hh:mm A')}
                    </div>
                )
            }
            <Tabs
                activeKey={currentTab}
                className={styles.tabs}
                onChange={setCurrentTab}
                items={tabItems}
            />
        </div>
    );
};

export default LeftPanel;
